import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import {
  getRouteWithPrevLocation,
  memberProfileModalPaths,
} from "@/react/helpers/urlHelpers";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { IconButton } from "../../IconButton";

export const NotificationSettingsButton = () => {
  const history = useHistory();

  return (
    <TippyV2 interactive={false} content={t("header_v3.notification_settings")}>
      <IconButton
        name="16-settings-gear"
        iconSize={20}
        ariaLabel={t("header_v3.notification_settings")}
        onClick={() =>
          history.push(
            getRouteWithPrevLocation({
              url: memberProfileModalPaths.notifications,
            }),
          )
        }
        iconClassName="!text-dark"
      />
    </TippyV2>
  );
};
